import { BoasVindasProps } from "../../../interfaces/props/SaudeBemEstar/UnimedAcolhe/BoasVindasProps";
import parse from 'html-react-parser';
import './styles.css'
import { Button, Checkbox, FormControlLabel } from "@mui/material";
import { sxButton, sxButtonAccessibility, sxCheckbox, sxOutlinedButton, sxOutlinedButtonAccessibility } from "./sxProps";
import { useAccessibility } from "../../../Store/contexts/AccessibilityContext";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { sxCheckboxContrast } from "../../../assets/styles/CommonSxProps";

function BoasVindasComponent(props: BoasVindasProps) {
    const accessibility = useAccessibility();
    const [checked, setChecked] = useState<boolean>(false);
    const navigate = useNavigate(); 

    const handleContinue = () => {
        props.handleWelcome(checked);
    }

    const handleShowDetails = () => {
        navigate('/saudeBemEstar/unimedAcolhe/boasVindas/oqueEUnimedAcolhe');
    }

    const handleDontShow = (event: React.ChangeEvent<HTMLInputElement>) => {
        setChecked(event.target.checked);
    };

    return (
        <div className="welcome-holder">
            <h1 className="welcome-title" style={accessibility.textTitleStyleAccessibility} >Olá, {props.benef[0].toUpperCase() + props.benef.substring(1).toLowerCase()}, seja bem-vindo(a) ao Unimed Acolhe</h1>
            <p className="welcome-description" style={accessibility.textStyleAccessibility}>{parse(props.text)}</p>
            <div className="welcome-buttons-holder mb">
                <div className="welcome-button">
                    <Button
                        variant="contained"
                        size="large"
                        onClick={handleContinue}
                        sx={sxButton}
                        style={{...accessibility.buttonStyleAccessibility, ...accessibility.buttonTextStyleAccessibility}}
                        fullWidth>
                        CONTINUAR
                    </Button>
                </div>
                <div className="welcome-button">
                    <Button
                        variant="outlined"
                        sx={accessibility.contrastMode ? sxOutlinedButtonAccessibility : sxOutlinedButton}
                        onClick={handleShowDetails}
                        fullWidth>
                        <span style={{color: '#00995D'}}>MAIS DETALHES</span>
                    </Button>
                </div>
            </div>
            <FormControlLabel 
                control={
                    <Checkbox 
                        onChange={handleDontShow}
                        style={accessibility.contrastColorAccessibility} />
                } 
                label="Não exibir mais esta tela" 
                sx={accessibility.contrastMode ? sxCheckboxContrast : sxCheckbox}/>
        </div>
    )
}

export default BoasVindasComponent;